import request from '../untils/request';

export const districtInviteLimitList = params => {
  return request({
    url: '/shop/invite-total-rule/index',
    params,
  });
};

export const inviteRulesIndex = params => {
  return request({
    url: '/shop/invite-rule/index',
    params,
  });
};

export const inviteRuleAddress = params => {
  return request({
    url: '/shop/invite-rule/address',
    params,
  });
};

export const inviteRuleCreate = params => {
  return request({
    url: '/shop/invite-rule/create-rule',
    params,
  });
};

export const inviteRuleEdit = params => {
  return request({
    url: '/shop/invite-rule/edit',
    params,
  });
};

export const inviteRuleEnable = params => {
  return request({
    url: '/shop/invite-rule/enable',
    params,
  });
};

export const inviteRuleClose = params => {
  return request({
    url: '/shop/invite-rule/close',
    params,
  });
};

// total
export const inviteRulesTotal = params => {
  return request({
    url: '/shop/invite-total-rule/index',
    params,
  });
};

export const inviteRulesTotalCreate = params => {
  return request({
    url: '/shop/invite-total-rule/create-rule',
    params,
  });
};

export const inviteRulesTotalEdit = params => {
  return request({
    url: '/shop/invite-total-rule/edit',
    params,
  });
};

export const inviteRulesTotalEnable = params => {
  return request({
    url: '/shop/invite-total-rule/enable',
    params,
  });
};

export const inviteRulesTotalClose = params => {
  return request({
    url: '/shop/invite-total-rule/close',
    params,
  });
};

export const inviteRecordErrorList = params => {
  return request({
    url: '/shop/invite-login-record/abnormal-list',
    params,
  });
};

export const inviteRecordList = params => {
  return request({
    url: '/shop/invite-login-record/index',
    params,
  });
};

export const exceptionList = params => {
  return request({
    url: '/shop/invite-login-record/exception-list',
    params,
  });
};


export const inviteShopLoginRecord = params => {
  return request({
    url: '/shop/invite-login-record/shop-login-record',
    params,
  });
};

export const inviteGetLoginRecordSetting = params => {
  return request({
    url: '/shop/invite-login-record/standard-setting',
    params,
  });
};

export const inviteUpdateSetting = params => {
  return request({
    url: '/shop/invite-login-record/update-standard-setting',
    params,
  });
};

export const inviteAdrressWithChilren = params => {
  return request({
    url: '/shop/invite-login-record/area-list',
    params,
  });
};
